import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CART_URL = 'https://bienestardigital.click/cart/add?id=43120004464729&quantity=1';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: 'default' | 'large';
}
export function CTAButton({
  children,
  className = '',
  size = 'default'
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'text-lg md:text-xl py-5 px-8 md:py-6 md:px-12' : 'text-base md:text-lg py-4 px-8';
  return <a href={CART_URL} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center justify-center gap-3 bg-brand-pink-600 text-white font-bold rounded-full shadow-lg hover:bg-brand-pink-700 hover:scale-[1.02] hover:shadow-xl active:scale-[0.98] transition-all ${sizeClasses} ${className}`} data-id="element-73">
      {children}
      <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-74" />
    </a>;
}